<template>
  <sidenav :orientation="orientation" :class="curClasses">

    <!-- Brand demo (see src/demo.css) -->
    <div class="app-brand demo" v-if="orientation !== 'horizontal'">
      <!-- <span class="app-brand-logo demo bg-primary">
        <svg viewBox="0 0 148 80" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><linearGradient id="a" x1="46.49" x2="62.46" y1="53.39" y2="48.2" gradientUnits="userSpaceOnUse"><stop stop-opacity=".25" offset="0"></stop><stop stop-opacity=".1" offset=".3"></stop><stop stop-opacity="0" offset=".9"></stop></linearGradient><linearGradient id="e" x1="76.9" x2="92.64" y1="26.38" y2="31.49" xlink:href="#a"></linearGradient><linearGradient id="d" x1="107.12" x2="122.74" y1="53.41" y2="48.33" xlink:href="#a"></linearGradient></defs><path style="fill: #fff;" transform="translate(-.1)" d="M121.36,0,104.42,45.08,88.71,3.28A5.09,5.09,0,0,0,83.93,0H64.27A5.09,5.09,0,0,0,59.5,3.28L43.79,45.08,26.85,0H.1L29.43,76.74A5.09,5.09,0,0,0,34.19,80H53.39a5.09,5.09,0,0,0,4.77-3.26L74.1,35l16,41.74A5.09,5.09,0,0,0,94.82,80h18.95a5.09,5.09,0,0,0,4.76-3.24L148.1,0Z"></path><path transform="translate(-.1)" d="M52.19,22.73l-8.4,22.35L56.51,78.94a5,5,0,0,0,1.64-2.19l7.34-19.2Z" fill="url(#a)"></path><path transform="translate(-.1)" d="M95.73,22l-7-18.69a5,5,0,0,0-1.64-2.21L74.1,35l8.33,21.79Z" fill="url(#e)"></path><path transform="translate(-.1)" d="M112.73,23l-8.31,22.12,12.66,33.7a5,5,0,0,0,1.45-2l7.3-18.93Z" fill="url(#d)"></path></svg>
      </span> -->
      <router-link to="/" class="app-brand-text demo sidenav-text font-weight-normal ml-2">Zarządca</router-link>
      <a href="javascript:void(0)" class="layout-sidenav-toggle sidenav-link text-large ml-auto" @click="toggleSidenav()">
        <i class="ion ion-md-menu align-middle"></i>
      </a>
    </div>
    <div class="sidenav-divider mt-0" v-if="orientation !== 'horizontal'"></div>

    <!-- Links -->
    <div class="sidenav-inner" :class="{ 'py-1': orientation !== 'horizontal' }">

      <!-- PORTALE -->
      <sidenav-router-link icon="ion ion-ios-at" :active="isMenuActive(`${basePath}/portale`)" :to="`${basePath}/portale`" :exact="true" v-if="hasRole(['Articles::FullAccess', 'Articles::List', 'Classifieds::FullAccess', 'Classifieds::Access', 'Comments::Access', 'Settings::FullAccess', 'Settings::Template'])">Portale</sidenav-router-link>

      <!-- OGŁOSZENIA -->
      <!-- <sidenav-divider class="mb-1" v-if="hasRole(['Classifieds::FullAccess', 'Classifieds::Access'])" />
      <sidenav-header class="small font-weight-semibold" v-if="hasRole(['Classifieds::FullAccess', 'Classifieds::Access'])">OGŁOSZENIA</sidenav-header>

      <sidenav-router-link icon="ion ion-md-list-box" :to="`${basePath}/ogloszenia`" :active="isMenuActive(`${basePath}/ogloszenia`)" :exact="true" v-if="hasRole(['Classifieds::FullAccess', 'Classifieds::Access'])">Ogłoszenia</sidenav-router-link>
      <sidenav-router-link icon="ion ion-md-bookmark" :to="`${basePath}/ogloszenia/kategorie`" :active="isMenuActive(`${basePath}/ogloszenia/kategorie`)" :exact="true" v-if="hasRole(['Classifieds::FullAccess', 'Classifieds::Access'])">Kategorie</sidenav-router-link> -->
      
      <!-- DASHBOARD -->
      <sidenav-divider class="mb-1" />
      <sidenav-header class="small font-weight-semibold">DANE</sidenav-header>
      <sidenav-router-link icon="ion ion-ios-speedometer" :active="isMenuActive(`${basePath}/podsumowanie`)" :to="`${basePath}/podsumowanie`" :exact="true">Podsumowanie</sidenav-router-link>
      <sidenav-router-link icon="ion ion-ios-videocam" :active="isMenuActive(`${basePath}/filmy`)" :to="`${basePath}/filmy`" :exact="true">Filmy</sidenav-router-link>
      <sidenav-router-link icon="ion ion-ios-image" :active="isMenuActive(`${basePath}/galerie`)" :to="`${basePath}/galerie`" :exact="true">Galerie</sidenav-router-link>

      <template v-if="hasRole(['Statistics::FullAccess', 'Statistics::Access'])">
        <!-- STATYSTYKI -->
        <sidenav-divider class="mb-1" />
        <sidenav-header class="small font-weight-semibold">Statystyki</sidenav-header>
        <sidenav-router-link icon="ion ion-md-speedometer" :active="isMenuActive(`${basePath}/statystyki`)" :to="`${basePath}/statystyki`" :exact="true">Statystyki</sidenav-router-link>
        <sidenav-router-link icon="ion ion-md-analytics" :active="isMenuActive(`${basePath}/cele`)" :to="`${basePath}/cele`" :exact="true">Cele</sidenav-router-link>
        <sidenav-router-link icon="ion ion-md-analytics" :active="isMenuActive(`${basePath}/artlist`)" :to="`${basePath}/artlist`" :exact="true">Lista artykułów dziennikarzy</sidenav-router-link>
      </template>

      <!-- STATYSTYKI
      <sidenav-divider class="mb-1"/>
      <sidenav-header class="small font-weight-semibold">DANE</sidenav-header>
      -->

      <!-- REKLAMY -->
      <sidenav-divider class="mb-1" v-if="hasRole(['Campaigns::FullAccess', 'Campaigns::Add', 'Campaigns::Edit', 'Campaigns::Delete'])" />
      <sidenav-header class="small font-weight-semibold" v-if="hasRole(['Campaigns::FullAccess', 'Campaigns::Add', 'Campaigns::Edit', 'Campaigns::Delete'])">REKLAMY</sidenav-header>

      <sidenav-router-link icon="ion ion-md-megaphone" :to="`${basePath}/reklamy/kampanie`" :active="isMenuActive(`${basePath}/reklamy/kampanie`)" :exact="true" v-if="hasRole(['Campaigns::FullAccess', 'Campaigns::Access'])">Kampanie</sidenav-router-link>

      <!-- QUIZES -->
      <sidenav-divider class="mb-1" />
      <sidenav-header class="small font-weight-semibold">Quizy</sidenav-header>
      <sidenav-router-link icon="ion ion-ios-speedometer" :active="isMenuActive(`${basePath}/quizy`)" :to="`${basePath}/quizy`" :exact="true">Quizy</sidenav-router-link>
      <sidenav-router-link v-if="hasRole(['Plebiscites::FullAccess', 'Plebiscites::Access'])" icon="ion ion-md-podium" :to="`${basePath}/sondy`" :active="isMenuActive(`${basePath}/sondy`)" :exact="true" >Sondy i Plebiscyty</sidenav-router-link>

      <!-- CRM -->
      <sidenav-divider class="mb-1" v-if="hasRole(['Clients::FullAccess', 'Clients::Access'])" />
      <sidenav-header class="small font-weight-semibold" v-if="hasRole(['Clients::FullAccess', 'Clients::Access'])">CRM</sidenav-header>

      <sidenav-router-link icon="ion ion-md-call" :to="`${basePath}/klienci`" :active="isMenuActive(`${basePath}/klienci`)" :exact="true" v-if="hasRole(['Clients::FullAccess', 'Clients::Access'])">Klienci</sidenav-router-link>

      <!-- INNE -->
      <sidenav-divider class="mb-1" v-if="hasRole(['Tags::FullAccess', 'Tags::Access'])" />
      <sidenav-header class="small font-weight-semibold"  v-if="hasRole(['Tags::FullAccess', 'Tags::Access'])">INNE</sidenav-header>

      <sidenav-router-link  v-if="hasRole(['Tags::FullAccess', 'Tags::Access'])" icon="ion ion-md-bookmark" :to="`${basePath}/tagi`" :active="isMenuActive(`${basePath}/tagi`)" :exact="true">Tagi</sidenav-router-link>
      <sidenav-router-link  v-if="hasRole(['Keywords::FullAccess', 'Keywords::Access'])" icon="ion ion-md-search" :to="`${basePath}/skluczowe`" :active="isMenuActive(`${basePath}/skluczowe`)" :exact="true">Słowa kluczowe</sidenav-router-link>
      <!--<sidenav-router-link  v-if="hasRole(['Links::FullAccess', 'Links::Access'])" icon="ion ion-md-link" :to="`${basePath}/linki`" :active="isMenuActive(`${basePath}/linki`)" :exact="true">Linki</sidenav-router-link>-->

      <!-- ADMINISTRACJA -->
      <sidenav-divider class="mb-1" v-if="hasRole(['Users::FullAccess', 'Users::View'])" />
      <sidenav-header class="small font-weight-semibold" v-if="hasRole(['Users::FullAccess', 'Users::View'])">UŻYTKOWNICY</sidenav-header>

      <sidenav-router-link icon="ion ion-md-people" :to="`${basePath}/uzytkownicy/grupy`" :active="isMenuActive(`${basePath}/uzytkownicy/grupy`)" :exact="true" v-if="hasRole(['Users::FullAccess', 'Users::View', 'Users::PermissionsChange'])">Grupy użytkowników</sidenav-router-link>

      <sidenav-router-link icon="ion ion-md-contact" :to="`${basePath}/uzytkownicy/admin`" :active="isMenuActive(`${basePath}/uzytkownicy/admin`)" :exact="true" v-if="hasRole(['Users::FullAccess', 'Users::View'])">Administracja</sidenav-router-link>
      <sidenav-router-link icon="ion ion-md-contacts" :to="`${basePath}/uzytkownicy/portal`" :active="isMenuActive(`${basePath}/uzytkownicy/portal`)" :exact="true" v-if="hasRole(['Users::FullAccess', 'Users::View'])">Portal</sidenav-router-link>

      <!-- WERSJONOWANIE -->
      <sidenav-divider class="mb-1" />
      <sidenav-header class="small font-weight-semibold">Wersja</sidenav-header>

      <sidenav-router-link icon="ion ion-md-list" :to="`${basePath}/wersja`" :active="isMenuActive(`${basePath}/wersja`)" :exact="true">Nowości w systemie</sidenav-router-link>

    </div>
  </sidenav>
</template>

<script>
import {
  Sidenav,
  SidenavLink,
  SidenavRouterLink,
  SidenavMenu,
  SidenavHeader,
  SidenavBlock,
  SidenavDivider,
} from '@/vendor/libs/sidenav';

export default {
  name: 'app-layout-sidenav',
  components: {
    /* eslint-disable vue/no-unused-components */
    Sidenav,
    SidenavLink,
    SidenavRouterLink,
    SidenavMenu,
    SidenavHeader,
    SidenavBlock,
    SidenavDivider,
    /* eslint-enable vue/no-unused-components */
  },

  props: {
    orientation: {
      type: String,
      default: 'vertical',
    },
    basePath: {
      type: String,
      default: '',
    },
  },

  computed: {
    curClasses() {
      let bg = this.layoutSidenavBg;

      if (
        this.orientation === 'horizontal' &&
        (bg.indexOf(' sidenav-dark') !== -1 ||
          bg.indexOf(' sidenav-light') !== -1)
      ) {
        bg = bg
          .replace(' sidenav-dark', '')
          .replace(' sidenav-light', '')
          .replace('-darker', '')
          .replace('-dark', '');
      }

      return (
        `bg-${bg} ` +
        (this.orientation !== 'horizontal'
          ? 'layout-sidenav'
          : 'layout-sidenav-horizontal container-p-x flex-grow-0')
      );
    },
  },

  methods: {
    isMenuActive(url) {
      return this.$route.path.indexOf(url) === 0;
    },

    isMenuOpen(url) {
      return (
        this.$route.path.indexOf(url) === 0 && this.orientation !== 'horizontal'
      );
    },

    toggleSidenav() {
      this.layoutHelpers.toggleCollapsed();
    },

    // hasRole(roles) {
    //   return roles.includes(this.$store.state.user.role);
    // },
  },
};
</script>
